import React from 'react';

import amplitude from 'amplitude-js';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import InvitePopup from 'apps/auth/components/invite/InvitePopup';
import { SHARE_LINK_CONFIRM_CLICKED, TRACK_MY_REFERRALS_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { AUTH_PROFILE_INVITE } from 'apps/auth/constants/UrlConstants';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const ShareInvitationLinkPopup = (props) => {
    return (
        <SimplePopup popupRef={props.popupRef} text={MarkdownService.splitByParagraph(props.text)}>
            <PopupButton
                type="button"
                iconName="share"
                text={props.shareInvitationLinkButton}
                onClick={() => {
                    amplitude.getInstance().logEvent(SHARE_LINK_CONFIRM_CLICKED);
                    props.popupRef.current?.open(<InvitePopup popupRef={props.popupRef} />);
                }}
            />
            <PopupButton
                type="link"
                iconName="list-marked"
                text={props.trackReferralsButton}
                href={AUTH_PROFILE_INVITE}
                onClick={() => {
                    amplitude.getInstance().logEvent(TRACK_MY_REFERRALS_CLICKED);
                    props.popupRef.current?.close();
                }}
            />
        </SimplePopup>
    );
};

export default ShareInvitationLinkPopup;
